import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { CartProvider } from './Componants/Header/CartContext';

// 👇 1. IMPORT THE AuthProvider
import { AuthProvider } from './Admin/context/AuthContext'; // **Adjust the path if necessary**

// Font Awesome setup
import { library } from '@fortawesome/fontawesome-svg-core';
import { faGauge, faBox, faCartShopping, faUsers, faGear, faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

library.add(faGauge, faBox, faCartShopping, faUsers, faGear, faChevronDown, faChevronRight);

root.render(
  <React.StrictMode>
    {/* 👇 2. WRAP YOUR APP WITH AuthProvider */}
    <AuthProvider>
      <CartProvider>
        <HelmetProvider>
      <App />
    </HelmetProvider>
      </CartProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();